import { identity } from 'lodash';
import { IHeaderDataPointConfig } from './shelter-profile.models';

export const PROFILE_SIDEBAR = {
  title: 'TOOLS',
  listData: [
    {
      human: 'Collapse panels',
      key: 'COLLAPSE_ALL_PANELS',
      icon: 'collapse',
    },
  ],
};

export const SIDEBAR_COLLAPSE = {
  title: 'TOOLS',
  listData: [
    {
      human: 'Collapse panels',
      key: 'COLLAPSE_ALL_PANELS',
      icon: 'collapse',
    },
  ],
};

export const SIDEBAR_EXPAND = {
  title: 'TOOLS',
  listData: [
    {
      human: 'Expand panels',
      key: 'EXPAND_ALL_PANELS',
      icon: 'expand',
    },
  ],
};

export const PANELS = {
  BASIC_INFO: {
    key: 'BASIC_INFO',
    expanded: true,
  },
  ATTENDANCE: {
    key: 'ATTENDANCE',
    expanded: false,
  },
};

export const HEADER_DATA_POINT_CONFIG: IHeaderDataPointConfig = {
  studentName: 'STUDENT_NAME_FIRST_LAST',
  dataPoints: [
    {
      key: () => 'SHELTER_OSIS_NUMBER',
      human: () => 'OSIS',
      formatFn: identity,
    },
    {
      key: () => 'CARES_ID',
      human: () => 'CARES ID',
      formatFn: identity,
    },
    {
      key: () => 'SHELTER_SCHOOL_DBN',
      human: () => 'School',
      formatFn: identity,
    },
    {
      key: ({ CLASS }) => (CLASS ? 'CLASS' : 'SHELTER_GRADE'),
      human: ({ CLASS }) => (CLASS ? 'Class' : 'Grade'),
      formatFn: identity,
    },
    {
      key: () => 'SHELTER_AGE',
      human: () => 'Age',
      formatFn: identity,
    },
    {
      key: () => 'IS_SPED',
      human: () => 'SWD',
      formatFn: (v: boolean) => {
        if (v) return 'yes';
        else if (v === false) return 'no';
        else return null;
      },
    },
    {
      key: () => 'IS_ELL',
      human: () => 'MLL',
      formatFn: (v: boolean) => {
        if (v) return 'yes';
        else if (v === false) return 'no';
        else return null;
      },
    },
  ],
};
